<template>
  <page-view class="page-contract-search mwclg-style contractSearch_new">
    <div slot="pageRight">
      <div class="order-search">
        <p class="title">{{ $t('ContractInquiry.ContractInquiry') }}</p>
        <div class="flex">
          <el-form
            ref="searchForm"
            :model="searchForm"
            style="flex: 1"
            :label-width="lang == 'zh' ? '140px' : '170px'"
          >
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item :label="$t('ContractInquiry.AgreementNumber')">
                  <el-input
                    v-model="searchForm.agreementNo"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('ContractInquiry.LegalEntityOfMilkyway')"
                >
                  <el-input
                    v-model="searchForm.legalEntityNameCn"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  >
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  :label="$t('ContractInquiry.ClientAgreementNumber')"
                >
                  <el-input
                    v-model="searchForm.customerAgreementNo"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item :label="$t('ContractInquiry.AgreementStatus')">
                  <el-select
                    v-model="searchForm.agreementStatus"
                    :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                    size="small"
                  >
                    <el-option
                      v-for="item in Object.values(PROTOCAL_STATUS)"
                      :key="item.id"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item :label="$t('ContractInquiry.AgreementStartDate')">
                  <!-- <el-date-picker
                    size="mini"
                    v-model="contractDate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                    end-placeholder="结束日期">
                  </el-date-picker> -->
                  <el-date-picker
                    size="small"
                    v-model="searchForm.startDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('ContractInquiry.AgreementEndDate')">
                  <el-date-picker
                    size="small"
                    v-model="searchForm.endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
          <div style="margin-top: 10px">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="search"
              >{{ $t('InvoiceInquiry.Inquire') }}</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh-right"
              @click="reset"
              >{{ $t('InvoiceInquiry.Reset') }}</el-button
            >
          </div>
        </div>
      </div>
      <div class="order-list">
        <p class="title">{{ $t('ContractInquiry.ContractList') }}</p>
        <div>
          <el-table
            v-loading="loading"
            :data="contractList"
            stripe
            style="width: 100%"
          >
            <el-table-column
              prop="agreementNo"
              :width="lang == 'zh' ? '130' : '220'"
              :label="$t('ContractInquiry.CompanyAgreementNumber')"
            >
            </el-table-column>
            <el-table-column
              v-if="lang == 'zh'"
              width="240"
              prop="legalEntityNameCn"
              :label="$t('ContractInquiry.LegalEntity')"
            >
            </el-table-column>
            <el-table-column
              v-else
              width="240"
              prop="legalEntityNameEn"
              :label="$t('ContractInquiry.LegalEntity')"
            >
            </el-table-column>
            <!-- <el-table-column
              width="240"
              prop="partnerNameCn"
              :label="$t('ContractInquiry.BusinessPartner')"
            >
            </el-table-column> -->
            <!-- <el-table-column
              :width="lang == 'zh' ? '120' : '180'"
              prop="signDate"
              :label="$t('ContractInquiry.AgreementSigningDate')"
            >
            </el-table-column> -->
            <el-table-column
              :width="lang == 'zh' ? '120' : '180'"
              prop="startDate"
              :label="$t('ContractInquiry.AgreementStartDate')"
            >
            </el-table-column>
            <el-table-column
              :width="lang == 'zh' ? '120' : '180'"
              prop="endDate"
              :label="$t('ContractInquiry.AgreementEndDate')"
            >
            </el-table-column>
            <!-- <el-table-column
              prop="agreementProperty"
              width="100"
              label="协议性质">
            </el-table-column> -->
            <!-- <el-table-column
              v-if="lang == 'zh'"
              width="120"
              prop="agreementStatus"
              :label="$t('ContractInquiry.AgreementStatus')"
            >
            </el-table-column>
            <el-table-column
              v-else
              width="150"
              prop="agreementStatusEn"
              :label="$t('ContractInquiry.AgreementStatus')"
            >
            </el-table-column> -->
            <el-table-column
              v-if="lang == 'zh'"
              width="100"
              prop="signproperty"
              :label="$t('ContractInquiry.NatureOfSignature')"
            >
            </el-table-column>
            <el-table-column
              v-else
              width="150"
              prop="signpropertyEn"
              :label="$t('ContractInquiry.NatureOfSignature')"
            >
            </el-table-column>
            <el-table-column
              :width="lang == 'zh' ? '100' : '190'"
              prop="customerAgreementNo"
              :label="$t('ContractInquiry.ClientAgreementNumber')"
            >
            </el-table-column>
            <!-- <el-table-column
              :width="lang == 'zh' ? '100' : '150'"
              prop="buploadFile"
              :label="$t('ContractInquiry.UploadFile')"
            >
              <template slot-scope="{ row }">
                <el-checkbox v-model="row.buploadFile" disabled></el-checkbox>
              </template>
            </el-table-column> -->
            <el-table-column
              width="120"
              prop="autoPostpone"
              :label="$t('ContractInquiry.AutoRenewal')"
            >
            </el-table-column>
            <el-table-column
              :width="lang == 'zh' ? '120' : '150'"
              prop="hasRelationCustomer"
              :label="$t('ContractInquiry.RelatedCustomers')"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components'
// import TableList from './modules/tableList'
import { getCusAgreement } from '@/api/contractSearch.js'
import i18n from '@/i18n/i18n'
// import { USER_INFO } from '@/store/mutation-types'
export default {
  name: 'InvoiceSearch',
  components: { PageView },
  data() {
    return {
      PROTOCAL_STATUS: [
        { name: i18n.t('ContractInquiry.Valid'), id: 0, value: '有效' },
        { name: i18n.t('ContractInquiry.Invalid'), id: 1, value: '无效' },
        { name: i18n.t('ContractInquiry.InCirculation'), id: 2, value: '流转中' },
        { name: i18n.t('ContractInquiry.NewImportUnconfirmed'), id: 3, value: '新导入未确认' },
        { name: i18n.t('ContractInquiry.Void'), id: 4, value: '作废' }
      ],
      searchForm: {
        agreementNo: '',
        legalEntityNameCn: '',
        agreementStatus: '有效',
        startDate: '',
        endDate: ''
      },
      loading: true,
      contractList: [],
      lang: 'zh'
    }
  },
  created() {
    this.search()
    this.lang = this.$ls.get('lang');
  },
  methods: {
    async search() {
      this.loading = true
      const { data } = await getCusAgreement(this.searchForm)
      if (data && data.length) {
        data.forEach(item => {
          item.createDt = /\d{4}-\d{1,2}-\d{1,2}/g.exec(item.createDt)
          item.startDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(item.startDate)
          item.endDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(item.endDate)
          item.signDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(item.signDate)
          item.buploadFile = Boolean(parseInt(item.buploadFile))
          item.hasRelationCustomer = item.hasRelationCustomer === 'false' ? i18n.t('InvoiceInquiry.No') : i18n.t('InvoiceInquiry.Yes')
          item.autoPostpone = item.autoPostpone === 'false' ? i18n.t('InvoiceInquiry.No') : i18n.t('InvoiceInquiry.Yes')
        })
      }
      this.loading = false
      this.contractList = data
    },
    reset() {
      this.searchForm = {
        agreementNo: '',
        legalEntityNameCn: '',
        agreementStatus: '',
        startDate: '',
        endDate: ''
      }
      this.contractDate = []
      this.search()
    }
    // search () {
    //   const userInfo = this.$ls.get(USER_INFO)
    //   this.queryParams.CustomerId = userInfo.CACode
    //   this.loading = true
    //   GetARByCusID(this.queryParams).then(res => {
    //     this.dataList = res.Data.CbList || []
    //     this.loading = false
    //   }).catch(() => {
    //     this.loading = false
    //   })
    // },
    // reset () {
    //   this.queryParams = {}
    //   this.search()
    // }
  }
}
</script>
<style lang="less">
.contractSearch_new {
  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
    height: auto !important;
  }
}
.page-contract-search {
  padding: 10px;
  background: #f0f6fb;
  // .plr25 {
  //   padding-left: 0px !important;
  //   padding-right: 0px !important;
  // }
  // .ptb25 {
  //   padding-top: 0px !important;
  //   padding-bottom: 0px !important;
  // }
  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    // min-height:60vh;
    .list-item {
      margin-bottom: 8px;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #51abc3 !important;
    border-color: #51abc3 !important;
  }
}
</style>
<style>
.el-select,
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.tms-style .el-input__inner {
  max-width: none;
}
.el-loading-mask {
  z-index: 1000;
}
</style>
